import { render, staticRenderFns } from "./FacturacionWellboat.vue?vue&type=template&id=20d86842"
import script from "./FacturacionWellboat.vue?vue&type=script&lang=js"
export * from "./FacturacionWellboat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports